import React from "react";
import { ReleaseDialog } from "./ReleaseDialog";

export const ReleaseDrawer = ({
  isOpen,
  setOpen,
}: {
  isOpen: boolean;
  setOpen: (v: boolean) => void;
}) => {
  return <ReleaseDialog isOpen={isOpen} setOpen={setOpen} />;
};
